var cilViewQuilt = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M16,64V448H496V64ZM464,240H192V96H464ZM192,272H312V416H192ZM48,96H160V416H48ZM344,416V272H464V416Z' class='ci-primary'/>"];

export { cilViewQuilt };

